(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  class TmRecentlyViewed extends HTMLElement {
    static STORAGE_KEY = 'tm_recently_viewed';
    static MAX_STORED = 9;
    static MAX_SHOWN = 4;

    connectedCallback() {
      this.#record();
      this.#render();
    }

    #read() {
      try {
        const raw = localStorage.getItem(TmRecentlyViewed.STORAGE_KEY);
        const list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list : [];
      } catch (error) {
        return [];
      }
    }

    #write(list) {
      try {
        localStorage.setItem(TmRecentlyViewed.STORAGE_KEY, JSON.stringify(list));
      } catch (error) {
        // Storage unavailable, silently skip.
      }
    }

    #record() {
      const handle = this.dataset.currentHandle;
      if (!handle) return;
      let list = this.#read().filter((h) => h !== handle);
      list.unshift(handle);
      list = list.slice(0, TmRecentlyViewed.MAX_STORED);
      this.#write(list);
    }

    async #render() {
      const handle = this.dataset.currentHandle;
      const handles = this.#read()
        .filter((h) => h !== handle)
        .slice(0, TmRecentlyViewed.MAX_SHOWN);

      if (!handles.length) return;

      const row = this.querySelector('[data-recent-row]');
      if (!row) return;

      const products = await Promise.all(
        handles.map((h) =>
          fetch(`/products/${h}.js`)
            .then((response) => (response.ok ? response.json() : null))
            .catch(() => null)
        )
      );

      const valid = products.filter(Boolean);
      if (!valid.length) return;

      valid.forEach((product) => {
        const price = (product.price / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
        const image = product.featured_image || (product.images && product.images[0]) || '';
        const card = document.createElement('a');
        card.className = 'tm-recent__card';
        card.href = `/products/${product.handle}`;
        card.innerHTML = `
          <span class="tm-recent__photo">${image ? `<img src="${image}" width="180" height="180" loading="lazy" alt="${product.title}">` : ''}</span>
          <span class="tm-recent__name">${product.title}</span>
          <span class="tm-recent__price">${price}</span>
        `;
        row.appendChild(card);
      });

      this.hidden = false;
    }
  }
  if (!customElements.get('tm-recently-viewed')) customElements.define('tm-recently-viewed', TmRecentlyViewed);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  class TmReviews extends HTMLElement {
    connectedCallback() {
      const bar = this.closest('.tm-reviews__inner');
      const prev = bar?.querySelector('[data-reviews-prev]');
      const next = bar?.querySelector('[data-reviews-next]');
      prev?.addEventListener('click', () => this.scrollBy({ left: -this.clientWidth * 0.9, behavior: 'smooth' }));
      next?.addEventListener('click', () => this.scrollBy({ left: this.clientWidth * 0.9, behavior: 'smooth' }));
    }
  }
  if (!customElements.get('tm-reviews')) customElements.define('tm-reviews', TmReviews);

  } catch(e) { console.error(e); }
})();
})();
